import { axios } from '@/utils';

export const postBranchService = async (values: any) => (await axios.post(`/branch`, values)).data.data;
export const patchBranchByIdService = async (id: string) =>
    (await axios.patch(`/users/branch/${id}`)).data.data;
